import createAsyncActions from 'shared/redux/helpers/create-async-actions';

const ACTIONS = createAsyncActions('CLIENT.VIDEO.REMOVE', ['SUCCESS']);
export const NAMES = ACTIONS.NAMES;
const { SUCCESS } = ACTIONS;

export { SUCCESS };


export default function (videoIds) {
  return function (dispatch) {
    dispatch(SUCCESS({ videoIds }, {}));
  };
}



// WEBPACK FOOTER //
// ./src/dashboard/redux/client/actions/videos/remove.js